export default "__VITE_ASSET__BIw7JuXQ__"